var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('HeaderMain',{attrs:{"title":"Контакты","subtitle":"Нужно указать к кому и куда обращаться по каким вопросам"}}),_c('ContainerContactsPreview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }